import { gql } from '@apollo/client';

export const IMAGE_UPLOAD_LINK = gql`
  mutation imageUploadLink(
    $filename: String!
    $size: Int!
    $sha256: String
    $token: String
  ) {
    imageUploadLink(
      filename: $filename
      size: $size
      sha256: $sha256
      token: $token
    ) {
      success
      uploadUrl
      fileName
      deduped
      message
    }
  }
`;

export const CONFIRM_IMAGE_UPLOAD = gql`
  mutation confirmImageUpload(
    $key: String!
    $sha256: String!
    $size: Int!
    $width: Int
    $height: Int
    $exif: ImageExifInput
    $token: String
  ) {
    confirmImageUpload(
      key: $key
      sha256: $sha256
      size: $size
      width: $width
      height: $height
      exif: $exif
      token: $token
    ) {
      success
    }
  }
`;
